import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SetBorrowerPairToDocumentParams {
  borrowerPairId: string;
  scope: string;
  documentId: string;
  isUserTaggedBorrower: boolean;
}

export interface SetBorrowerPairToDocumentResponse {
  message: string;
}

const setBorrowerPairToDocument: MutationFunction<
  SetBorrowerPairToDocumentResponse,
  SetBorrowerPairToDocumentParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetBorrowerPairToDocumentResponse>(
    `/documents/${args.documentId}/borrower`,
    {
      method: 'PATCH',
      body: {
        borrowerPairId: args.borrowerPairId,
        scope: args.scope,
        isUserTaggedBorrower: args.isUserTaggedBorrower,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set borrower pair to document');
};

export default setBorrowerPairToDocument;

const _mockType = {
  message: 'Borrower pair set successfully',
};
